export default {
    course: {
        unit: {
            '2a': 'How the Ideas Fit Together',
            '2b': '{{name}} - Creating a Question/Answer Dialogue'
        }
    },
    dashboard: {
        'currently-on-section': 'You are currently on section',
        'progress': '{{name}}You have completed <span class="course-info__marked percentege">{{count}}%</span> of the course',
        'logout': 'Logout'
    }
};



// WEBPACK FOOTER //
// ./client/app/modules/dashboard/i18n/en.js